export default "__VITE_PUBLIC_ASSET__43aa0aab__"